import React, { useEffect, useContext, useState } from "react";
import { Typography, MenuItem, Box } from "@mui/material";
import TableChartIcon from "@mui/icons-material/TableChart";
import { alpha } from "@mui/material/styles";
import { AuthContext } from "../../../../contexts/AuthContext";

const ExcelBase = ({ generateExcel }) => {
  const { global_authState } = useContext(AuthContext);
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);

  useEffect(() => {
    const status = global_authState?.subscription?.status || null;
    setSubscriptionStatus(status);
  }, [global_authState?.subscription?.status]);

  const downloadDraftExcel = async () => {
    try {
      if (generateExcel) {
        await generateExcel(true);
      }
    } catch (error) {
      console.error("Error generating Excel:", error);
    }
  };

  const downloadExcel = async () => {
    try {
      if (generateExcel) {
        await generateExcel(false);
      }
    } catch (error) {
      console.error("Error generating Excel:", error);
    }
  };

  return (
    <>
      <Box
        sx={{
          px: 2,
          py: 1.5,
          borderBottom: 1,
          borderColor: "divider",
          mb: 1,
        }}
      >
        <Typography
          variant='subtitle2'
          sx={{
            fontWeight: 600,
            color: "success.main",
            textTransform: "uppercase",
            letterSpacing: 0.5,
            fontSize: "0.75rem",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          Excel Options
        </Typography>
      </Box>

      <MenuItem
        onClick={downloadDraftExcel}
        sx={{
          borderRadius: 1,
          mx: 1,
          mb: 1,
          py: 1.5,
          "&:hover": {
            bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            width: "100%",
          }}
        >
          <Box
            sx={{
              width: 36,
              height: 36,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 1,
              bgcolor: (theme) => alpha(theme.palette.success.main, 0.1),
            }}
          >
            <TableChartIcon color='success' fontSize='small' />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography variant='body2' sx={{ fontWeight: 500 }}>
              Export Draft
            </Typography>
            <Typography variant='caption' color='text.secondary'>
              Save draft as Excel file
            </Typography>
          </Box>
        </Box>
      </MenuItem>

      <MenuItem
        onClick={downloadExcel}
        sx={{
          borderRadius: 1,
          mx: 1,
          mb: 1,
          py: 1.5,
          "&:hover": {
            bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            width: "100%",
          }}
        >
          <Box
            sx={{
              width: 36,
              height: 36,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 1,
              bgcolor: (theme) => alpha(theme.palette.success.main, 0.1),
            }}
          >
            <TableChartIcon color='success' fontSize='small' />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography variant='body2' sx={{ fontWeight: 500 }}>
              Export Final
            </Typography>
            <Typography variant='caption' color='text.secondary'>
              Export final schedule as Excel file
            </Typography>
          </Box>
        </Box>
      </MenuItem>
    </>
  );
};

export default ExcelBase;
